import TabA from '@/componentsH5/EcoCreditsDay/components/PageTabs/TabA';
import TabB from '@/componentsH5/EcoCreditsDay/components/PageTabs/TabB';
import TabC from '@/componentsH5/EcoCreditsDay/components/PageTabs/TabC';
import EarnMore from '@/componentsH5/EcoCreditsDay/components/PageTabs/TabB/EarnMore';
import UseSpecials from '@/componentsH5/EcoCreditsDay/components/PageTabs/TabB/UseSpecials';

const TAB_NUM = 2;
const ZA_TAB_NUM = 3;
const KR_TAB_NUM = 1;

const TAB_HEIGHT = 70;
const TAB_MARGIN = 40;

const tabsContent = {
    jp: [
        {
            element: <TabA />,
            id: 'tab_content_0',
        },
        {
            element: <TabB />,
            id: 'tab_content_1',
        },
        {
            element: <TabC />,
            id: 'tab_content_2',
        },
    ],
    au: [
        {
            element: <TabB />,
            id: 'tab_content_0',
        },
        {
            element: <EarnMore />,
            id: 'tab_content_1',
        },
        {
            element: <UseSpecials />,
            id: 'tab_content_2',
        },
    ],
    za: [
        // {
        //     element: <TabA />,
        //     id: 'tab_content_0',
        // },
        {
            element: <TabB />,
            id: 'tab_content_0',
        },
        {
            element: <EarnMore />,
            id: 'tab_content_1',
        },
        {
            element: <UseSpecials />,
            id: 'tab_content_2',
        },
    ],
};

const MUTI_AREA_ARR = ['za', 'uk', 'de', 'fr', 'it', 'es', 'eu', 'au', 'us', 'ca'];
const SCROLL_CARD_ARR = ['jp', 'kr', 'uk', 'eu', 'de', 'fr', 'it', 'es', 'us', 'ca'];

export { TAB_HEIGHT, TAB_NUM, ZA_TAB_NUM, KR_TAB_NUM, tabsContent, MUTI_AREA_ARR, SCROLL_CARD_ARR, TAB_MARGIN };
